import { Component, OnInit } from '@angular/core';
import { DDFSQuoteModel, DDFSQuoteLineModel, DDFSCombineModel } from '../../models/shopping-cart.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { DDFSQuoteResponse, DDFSQuoteTermLine, DDFSQuoteTermResponse, ApiResponse } from '../../models/api-response.model';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-financial-summary',
  templateUrl: './financial-summary.component.html',
  styleUrls: ['./financial-summary.component.css']
})
export class FinancialSummaryComponent implements OnInit {

  title = 'Financing Summary';
  loadContent = false;
  setFullWindow = false;
  quote: DDFSQuoteModel;
  financeType: string;
  cartId: string;
  cartName: string;
  accountNumber = '';
  accountName = '';
  bsb = '';
  displayedColumns: string[];
  displayedColumnsAdditional: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
  displayedColumnsPass: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
  shoppingCartItems: DDFSQuoteLineModel[] = [];
  additionalCharges: DDFSQuoteLineModel[] = [];
  passThroughCharges: DDFSQuoteLineModel[] = [];
  terms: DDFSQuoteTermLine[] = [];
  ddfsCombine: DDFSCombineModel;
  ddfsQuote: DDFSQuoteResponse;
  selectedTerm: DDFSQuoteTermLine;
  dataSourceItems = new MatTableDataSource();
  dataSourceAdditionalCharge = new MatTableDataSource();
  dataSourcePastThrough = new MatTableDataSource();
  url: string;
  totalPrice: number;
  additionalChargeTotalPrice: number;
  passThroughChargeTotalPrice: number;
  companyName: string;
  quoteName: string;
  abn: string;
  name: string;
  email: string;
  phone: string;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private commonService: CommonService,
    private shoppingCartService: ShoppingCartService
  ) { }

  ngOnInit() {
    this.loadContent = false;
    if (this.activeRouter.parent.parent.parent) {
      this.activeRouter.url.subscribe(result => {
        $('#levelOne').animate({ scrollLeft: $('#finance').width() + $('#finance-details').width() + $('#cart-summary').width() + 250 }, 400);
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
      this.activeRouter.parent.paramMap.subscribe(query => {
        this.financeType = query.get('type').toLowerCase();
        if (this.financeType === 'enduser') {
          this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE', 'SELLINGPRICE', 'SELLINGLINEPRICE'];
        } else {
          this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
        }
        this.activeRouter.parent.parent.parent.paramMap.subscribe(res => {
          if (res) {
            this.cartId = res.get('id');
            this.cartName = res.get('cartName');
            this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((value: DDFSQuoteResponse) => {
              this.loadContent = true;
              this.totalPrice = 0;
              this.additionalChargeTotalPrice = 0;
              this.passThroughChargeTotalPrice = 0;
              if (value) {
                this.quote = value.quote;
                this.ddfsQuote = value;
                this.quoteName = decodeURIComponent(this.quote.name);
                this.companyName = this.quote.companyName;
                this.abn = this.quote.abn;
                this.name = this.quote.contactName;
                this.email = this.quote.email;
                this.phone = this.quote.phone;
                // this.accountNumber = this.quote.accountNumber == "0" ? "" : this.quote.accountNumber;
                // this.accountName = this.quote.accountName;
                // this.bsb = this.quote.bsb;
                this.shoppingCartService.GetFinanceQuoteTermAmount(value).subscribe((termRes: DDFSQuoteTermResponse) => {
                  this.loadContent = true;
                  this.shoppingCartItems = value.items;
                  if (value && value.additionalChanrges.length) {
                    this.additionalCharges = value.additionalChanrges.filter(x => x.description);
                  }
                  if (value && value.passThroughChanrges.length) {
                    this.passThroughCharges = value.passThroughChanrges.filter(x => x.description);
                  }
                  if (this.passThroughCharges && this.passThroughCharges.length) {
                    this.passThroughCharges.forEach(ac => {
                      ac.lineSellPrice = ac.sellPrice * ac.quantity;
                      this.passThroughChargeTotalPrice += ac.lineSellPrice;
                    });
                    this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
                  }
                  if (this.additionalCharges && this.additionalCharges.length) {
                    this.additionalCharges.forEach(ac => {
                      ac.lineSellPrice = ac.sellPrice * ac.quantity;
                      this.additionalChargeTotalPrice += ac.lineSellPrice;
                    });
                    this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
                  }
                  this.shoppingCartItems.forEach(item => {
                    item.linePrice = item.unitPrice * item.quantity;
                    if (this.financeType === 'enduser') {
                      this.totalPrice += item.lineSellPrice;
                    } else {
                      this.totalPrice += item.linePrice;
                    }
                  });
                  this.dataSourceItems = new MatTableDataSource(this.shoppingCartItems);
                  if (termRes && termRes.terms) {
                    this.terms = termRes.terms;
                    if (this.quote.termInMonths) {
                      this.selectedTerm = this.terms.filter(ter => ter.termId === this.quote.termInMonths)[0];
                    } else {
                      this.selectedTerm = this.terms[0];
                    }
                  }
                },
                  (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                  });
              } else {
                this.loadContent = true;
              }
            },
              (error: any) => {
                console.error(error);
                this.loadContent = true;
              });
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  sendQuote(): void {
    let flag = true;
    if (!this.companyName) {
      this.commonService.showError('.companyinput', 'Company name can not be empty', 'right');
      flag = false;
    }
    if (!this.name) {
      this.commonService.showError('.nameinput', 'Contact name can not be empty', 'right');
      flag = false;
    }
    if (!this.email) {
      this.commonService.showError('.emailinput', 'Email can not be empty', 'right');
      flag = false;
    }
    if (!this.phone) {
      this.commonService.showError('.phoneinput', 'Phone number can not be empty', 'right');
      flag = false;
    }
    if (flag) {
      this.quote.companyName = this.companyName;
      this.quote.abn = this.abn;
      this.quote.contactName = this.name;
      this.quote.email = this.email;
      this.quote.phone = this.phone;
      this.loadContent = false;
      this.shoppingCartService.SaveQuoteDetail(this.quote).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.ddfsCombine = {
            quote: this.quote,
            terms: this.terms,
            ddfsQuote: this.ddfsQuote
          };
          this.shoppingCartService.SendQuote(this.financeType, this.ddfsCombine).subscribe((response: ApiResponse) => {
            this.loadContent = true;
            if (response && response.status) {
              this.shoppingCartService.monitorStatusChange(4);
              this.commonService.showSuccess('.sendquote', response.responseMessage, 'right');
              setTimeout(() => {
                this.router.navigateByUrl('/financequotes/summary/' + this.cartId + '/' + this.cartName);
              }, 1000);
            } else {
              this.commonService.showError('.sendquote', response.responseMessage, 'right');
            }
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        } else {
          this.loadContent = true;
          this.commonService.showError('.sendquote', res.responseMessage, 'right');
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close(): void {
    this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName + '/finance/financeDetails/' + this.financeType);
  }
}
